import { Link } from "react-router-dom";
import { IoIosBeer } from "react-icons/io";
import { GiBeerStein } from "react-icons/gi";
import { BiArrowToTop } from "react-icons/bi";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { MdAddCircleOutline, MdOutlineMore } from "react-icons/md";

import { Button } from "../../components/Button";
import { Header } from "../../components/Header";
import { useDrinks } from "../../providers/beers";
import { useMarriageDrink } from "../../providers/marriage";
import { useGraduationDrink } from "../../providers/graduation";
import { useConfraternizationDrink } from "../../providers/confraternization";

import { Container, Foot, Pages } from "./styles";

export const BeersList = () => {
  const {
    drinks,
    isOpen,
    setIsOpen,
    isClose,
    setIsClose,
    nextPage,
    previousPage,
  } = useDrinks();

  const { addDrinkMarriage } = useMarriageDrink();
  const { addDrinkGraduation } = useGraduationDrink();
  const { addDrinkConfraternization } = useConfraternizationDrink();

  const openModal = () => setIsOpen(!isOpen);

  const openDescriptionModal = () => setIsClose(!isClose);

  return (
    <>
      <Header>
        <h1>
          Be
          <IoIosBeer />i<GiBeerStein />
          as
        </h1>
      </Header>
      <Container>
        {drinks.map((beer, index) => (
          <div className="main" key={index}>
            <img src={beer.image_url} alt={beer.name} />
            <p className="drinkName">{beer.name}</p>
            <p className="first-brewed">{beer.first_brewed}</p>

            <div className="viewMore">
              <span>
                Description
                <MdOutlineMore onClick={openDescriptionModal} />
              </span>
              {isClose === false && (
                <div className="description">{beer.description}</div>
              )}
            </div>
            <p className="volume">
              {beer.volume.value} {beer.volume.unit}
            </p>
            <div className="buttonDivision">
              <Button autumnFern onClick={() => addDrinkMarriage(beer)}>
                Casamento
                <MdAddCircleOutline />
              </Button>
              <Button autumnFern onClick={() => addDrinkGraduation(beer)}>
                Formatura
                <MdAddCircleOutline />
              </Button>
              <Button
                autumnFern
                onClick={() => addDrinkConfraternization(beer)}
              >
                Confraternização
                <MdAddCircleOutline />
              </Button>
            </div>
            {isOpen && (
              <section>
                <div className="buttonOne"></div>
                <div className="buttonTwo"></div>
                <div className="buttonThree"></div>
                <div className="closeModal">
                  <AiOutlineCloseCircle onClick={openModal} />
                </div>
                <aside className="differentPages">
                  <div className="linkOne">
                    <Link to="/confraternization" onClick={openModal}>
                      Confraternização
                    </Link>
                  </div>
                  <div className="linkTwo">
                    <Link to="/graduation" onClick={openModal}>
                      Formatura
                    </Link>
                  </div>
                  <div className="linkThree">
                    <Link to="/marriage" onClick={openModal}>
                      Casamento
                    </Link>
                  </div>
                </aside>
              </section>
            )}
          </div>
        ))}
      </Container>
      <Pages>
        <Button onClick={previousPage}>Previous</Button>
        <Button onClick={nextPage}>Next</Button>
      </Pages>
      <Foot>
        <a href="#top">
          <BiArrowToTop />
        </a>
      </Foot>
    </>
  );
};
